import type { PointTuple } from "./types";

export interface TapeMeasurement {
  start: PointTuple;
  end: PointTuple;
  length: number;
  deltaX: number;
  deltaY: number;
}

export function measureBetween(start: PointTuple, end: PointTuple): TapeMeasurement {
  const deltaX = end[0] - start[0];
  const deltaY = end[1] - start[1];
  return { start, end, deltaX, deltaY, length: Math.hypot(deltaX, deltaY) };
}
